import React, { useState } from 'react'
import { Accordion } from 'react-bootstrap';
import { sidebar } from '../routes/Sidebar';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
// import Logo from '../css/laptopA.png';
import LogoutIcon from "@mui/icons-material/Logout";
import ModalBox from '../components/modal/ModalBox';
import SubMenu from './SubMenu';



const Sidebar = () => {
    const [logoutModal, setLogoutModal] = useState(false);
    const navigate = useNavigate()
    const location = useLocation();

    function logoutHandler() {
        navigate("/")
        localStorage.clear();
    }
    return (
        <div>
            <Accordion defaultActiveKey="0">
                <div className="SidenavArea">
                    <div className="SidenavHead">
                        {/* <div className="Logo">
                            <img src={Logo || ""} alt={"Logo"} />
                        </div> */}
                        <h2 style={{ color: "#C86337", fontWeight: "900" }}>Neptune</h2>
                    </div>
                    <div className="SidenavBody">
                        <ul>
                            {sidebar([]).map(({ path, icon, name, isChild }, index) => {
                                return isChild ? (
                                    <SubMenu
                                        isChild={isChild}
                                        icon={icon}
                                        path={path}
                                        name={name}
                                        key={path}
                                    />
                                ) : (
                                    <li
                                        className={location.pathname === path ? "active" : ""}
                                        key={path}
                                    >
                                        <NavLink to={path}>
                                            <span>{icon}</span>
                                            <p>{name}</p>
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <div className="SidenavFooter">
                        <Link onClick={() => setLogoutModal(true)}>
                            <span className="mx-2">
                                <LogoutIcon fontSize="small" sx={{ color: "#fff" }} />
                            </span>
                            Logout
                        </Link>
                    </div>
                </div>
            </Accordion>
            <ModalBox
                status={logoutModal}
                onClose={() => setLogoutModal(false)}
                title={"Logout"}
                description={"Are you sure want to logout?"}
                action={logoutHandler}
            />
        </div>
    )
}

export default Sidebar